import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { makeBgImage } from '../../../../../helpers/common';
import { propShape } from '../../../../../helpers/custom-prop-types';
const classForThumbnail = (solution) => {
    const noImage = !solution.thumbnail ? 'no-image ' : '';
    if (solution.status === 1)
        return `${noImage}is-rough`;
    if (solution.status === 2)
        return `${noImage}is-exam`;
    return '';
};
const OverViewThumbnail = ({ solution }) => (_jsx("div", { className: `overview-thumbnail  ${classForThumbnail(solution)}`, style: makeBgImage(solution.thumbnail) }));
OverViewThumbnail.propTypes = {
    solution: propShape().isRequired,
};
export default OverViewThumbnail;
